import React, { useState, useEffect, useRef } from "react";
import {
  Box, 
  Flex,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  Avatar,
  Button,
  Td,
  chakra,
  SimpleGrid,
  Stat,
  StatLabel,
  StatNumber,
  useToast,
  Spinner,
  useColorModeValue,
  useStyleConfig,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
} from "@chakra-ui/react";
import { BsPerson } from 'react-icons/bs'
import { CiExport } from "react-icons/ci";
import { FaRegTrashAlt } from "react-icons/fa";
import { useLocation, useNavigate } from 'react-router-dom';
import axios from "axios";
import { saveAs } from 'file-saver';
import Footer from '../Footer/Footer';
import avatar from "../../assets/img/user.png";

const contryIcon = {
  "Bénin": "🇧🇯",
  "Burkina Faso": "🇧🇫",
  "Cap-Vert": "🇨🇻",
  "Côte d'Ivoire": "🇨🇮",
  "Gambie": "🇬🇲",
  "Ghana": "🇬🇭",
  "Guinée": "🇬🇳",
  "Guinée-Bissau": "🇬🇼",
  "Libéria": "🇱🇷",
  "Mali": "🇲🇱",
  "Mauritanie": "🇲🇷",
  "Niger": "🇳🇪",
  "Nigeria": "🇳🇬",
  "Sénégal": "🇸🇳",
  "Sierra Leone": "🇸🇱",
  "Togo": "🇹🇬"
}

function Card(props) {
  const { variant, children, ...rest } = props;
  const styles = useStyleConfig("Card", { variant });
  // Pass the computed styles into the `__css` prop
  return (
    <Box __css={styles} {...rest}>
      {children}
    </Box>
  );
}

function CardBody(props) {
  const { variant, children, ...rest } = props;
  const styles = useStyleConfig("CardBody", { variant });
  // Pass the computed styles into the `__css` prop
  return (
    <Box __css={styles} {...rest}>
      {children}
    </Box>
  );
}

function CardHeader(props) {
  const { variant, children, ...rest } = props;
  const styles = useStyleConfig("CardHeader", { variant });
  // Pass the computed styles into the `__css` prop
  return (
    <Box __css={styles} {...rest}>
      {children}
    </Box>
  );
}

function Home() {
  const [data, setData] = useState([]);
  const location = useLocation();
  const toast = useToast();
  const toastIdRef = useRef();
  const navigate = useNavigate();
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const cancelRef = useRef();

  const onCloseAlert = () => setIsAlertOpen(false);

  const handleDeleteClick = (id) => {
    setSelectedId(id);
    setIsAlertOpen(true);
  };

  useEffect(() => {
    if (!location.state || (location.state && !location.state.loginData)) {
      navigate('/dashboard/login');
    }
  }, [location.state, navigate]);

  const handleDeleteConfirm = async () => {
    onCloseAlert();
    try {
      toastIdRef.current = toast({
        icon: <Spinner />,       
        title: "Suppression en cours",
        description: "Veuillez patienter...",
        status: "loading",
        duration: null,
        isClosable: true,
      });
      const response = await axios.delete(`https://cicabank.com/survey/${selectedId}`, {
        headers: {
          'Authorization': `Basic ${btoa(`${location.state.loginData.username}:${location.state.loginData.password}`)}`
        }
      });
      if (response.status === 200) {
        if (toastIdRef.current) {
          toast.update(toastIdRef.current, {
            title: "Suppression réussie",
            description: "La suppression de l'inscription est effectuée !",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
        }
        window.location.reload(); // Reload the page after successful deletion
      }
    } catch (error) {
      console.error('error', error);
      toast.update(toastIdRef.current, {
        title: "Erreur",
        description: "Une erreur s'est produite. Veuillez réessayer.",
        status: "error",
        duration: 9000,
        isClosable: true,
      })
      console.error('There was an error!', error);
    }
  };  

  function TablesTableRow(props) {
    const { id, logo, name, email, country, city, phone, date } = props;
    const textColor = useColorModeValue("gray.700", "white");
  
    return (
      <Tr>
        <Td minWidth={{ sm: "250px" }} pl="0px">
          <Flex align="center" py=".8rem" minWidth="100%" flexWrap="nowrap">
            <Avatar src={logo} w="50px" borderRadius="12px" me="18px" />
            <Flex direction="column">
              <Text
                fontSize="md"
                color={textColor}
                fontWeight="bold"
                minWidth="100%"
              >
                {name}
              </Text>
              <Text fontSize="sm" color="gray.400" fontWeight="normal">
                {email}
              </Text>
            </Flex>
          </Flex>
        </Td>
  
        <Td>
          <Flex direction="column">
            <Text fontSize="md" color={textColor} fontWeight="bold">
              {country}
            </Text>
            <Text fontSize="sm" color="gray.400" fontWeight="normal">
              {city}
            </Text>
          </Flex>
        </Td>
        <Td>
          <Text fontSize="md" color={textColor} fontWeight="bold">
            {phone}
          </Text>
        </Td>
        <Td>
          <Text fontSize="md" color={textColor} fontWeight="bold" pb=".5rem">
            {date}
          </Text>
        </Td>
        <Td>
          <Flex justifyContent="flex-end">
          <Button p="0px" bg="transparent" variant="no-hover" mr={2} onClick={() => navigate(`/dashboard/survey/${id}`, { state: {loginData: { username: location.state.loginData.username, password: location.state.loginData.password }}})}>
            <Text
              fontSize="md"
              color="gray.400"
              fontWeight="bold"
              cursor="pointer"
            >
              Voir
            </Text>
          </Button>
          <Button p="0px" bg="transparent" variant="no-hover" onClick={() => handleDeleteClick(id)}>
            <FaRegTrashAlt size="1.5em" color="red" />
          </Button>
          </Flex>
        </Td>
      </Tr>
    );
  }

  function StatsCard(props) {
    const { title, stat, icon } = props
    return (
      <Stat
        px={{ base: 2, md: 4 }}
        py={'5'}
        shadow={'xl'}
        border={'1px solid'}
        borderColor={useColorModeValue('gray.800', 'gray.500')}
        rounded={'lg'}>
        <Flex justifyContent={'space-between'}>
          <Box pl={{ base: 2, md: 4 }}>
            <StatLabel fontWeight={'medium'} isTruncated>
              {title}
            </StatLabel>
            <StatNumber fontSize={'2xl'} fontWeight={'medium'}>
              {stat}
            </StatNumber>
          </Box>
          <Box
            my={'auto'}
            color={useColorModeValue('gray.800', 'gray.200')}
            alignContent={'center'}>
            {icon}
          </Box>
        </Flex>
      </Stat>
    )
  }
  
  const Authors = ({ title, captions, data }) => {
    const textColor = useColorModeValue("gray.700", "white");
    function formatDate(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Les mois commencent à 0
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }
    
    return (
      <Card overflowX={{ sm: "scroll", xl: "hidden" }}>
        <CardHeader p='6px 0px 22px 0px'>
        <Box maxW="7xl" mx={'auto'} pt={5} px={{ base: 2, sm: 12, md: 17 }}>
          <chakra.h1 textAlign={'center'} fontSize={'4xl'} py={10} fontWeight={'bold'}>
            {title}
          </chakra.h1>
          <SimpleGrid columns={{ base: 1, md: 3 }} spacing={{ base: 10, lg: 16 }}>
            <Box gridColumn={{ base: "span 3", md: "span 1" }}>
            </Box>
            <Box gridColumn={{ base: "span 3", md: "span 1" }}>
              <StatsCard title={'Inscrits'} stat={data.length} icon={<BsPerson size={'3em'} />} />
            </Box>
            <Box gridColumn={{ base: "span 3", md: "span 1" }} textAlign={{ base: "center", md: "right" }}>
              <Button 
                size={{base: "md", md: "lg"}} 
                variant='outline' 
                mt={{ base: 0, md: 4 }} 
                rightIcon={<CiExport />} 
                colorScheme='yellow'
                onClick={handleExport}
              > 
                Export 
              </Button>
            </Box>
          </SimpleGrid>
        </Box>
        </CardHeader>
        <CardBody>
          <Box bg={useColorModeValue('gray.50', 'gray.900')} shadow={'xl'} rounded={'lg'} pl={{base: 2, md: 4}} borderColor={useColorModeValue('gray.200', 'gray.700')} borderWidth={1} mt={10} mx={{base: 2, md: 4}}>
          <Table variant='simple' color={textColor} >
            <Thead>
              <Tr my='.8rem' pl='0px' color='gray.400'>
                {captions.map((caption, idx) => {
                  return (
                    <Th fontSize="sm" color={textColor} fontWeight="bold" key={idx} ps={idx === 0 ? "0px" : null}>
                      {caption}
                    </Th>
                  );
                })}
              </Tr>
            </Thead>
            <Tbody>
              {data.map((row) => {
                return (
                  <TablesTableRow
                    key={row._id}
                    id={row._id}
                    name={`${row.lastName} ${row.firstName}`}
                    logo={avatar}
                    email={row.email}
                    country={`${contryIcon[row.country]}  ${row.country}`}
                    city={row.city}
                    phone={row.phone}
                    date={formatDate(row.createdAt)}
                  />
                );
              })}
            </Tbody>
          </Table>
          </Box>
        </CardBody>
      </Card>
    );
  };

  const fetchData = async () => {
    try {
      const response = await axios.post('https://cicabank.com/survey/all', {

      }, {
        headers: {
          'Authorization': `Basic ${btoa(`${location.state.loginData.username}:${location.state.loginData.password}`)}`
        }
      });
      if (response.status === 200 && Array.isArray(response.data)) {
        setData(response.data);
      }
    } catch (error) {
      console.error('error', error);
      toast({
        title: "Erreur",
        description: "Une erreur s'est produite. Veuillez recharger la page.",
        status: "error",
        duration: 9000,
        isClosable: true,
      })
      console.error('There was an error!', error);
    }
  }

  const handleExport = async () => {
    try {
      toastIdRef.current = toast({
        icon: <Spinner />,       
        title: "Requête en cours de traitement",
        description: "Veuillez patienter...",
        status: "loading",
        duration: null,
        isClosable: true,
      });
      const response = await axios.post('https://cicabank.com/survey/export', {

      }, {
        headers: {
          'Authorization': `Basic ${btoa(`${location.state.loginData.username}:${location.state.loginData.password}`)}`
        },
        responseType: 'blob' // Important pour recevoir le fichier en tant que Blob
      });
      if (response.status === 200) {
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'surveys.xlsx');
        if (toastIdRef.current) {
          toast.update(toastIdRef.current, {
            title: "Téléchargement réussie",
            description: "Le téléchargement du fichier a commencé !",
            status: "success",
            duration: 5000,
            isClosable: true,
          })
        }
      }
    } catch (error) {
      console.error('error', error);
      toast.update(toastIdRef.current, {
        title: "Erreur",
        description: "Une erreur s'est produite. Veuillez réessayer.",
        status: "error",
        duration: 9000,
        isClosable: true,
      })
      console.error('There was an error!', error);
    }
  };

  if (data.length === 0 && location.state && location.state.loginData) {
    fetchData();
  }

  return (
    <>
    <Flex direction='column' pt={{ base: "2px", md: "4px" }} m={8} minH={'100vh'}>
      <Authors
        title={"Liste des inscrits"}
        captions={["", "Pays/Ville", "Numéro de téléphone", "Date d'inscription", ""]}
        data={Array.isArray(data) ? data : []}
      />
    </Flex>
    <AlertDialog
      isOpen={isAlertOpen}
      leastDestructiveRef={cancelRef}
      onClose={onCloseAlert}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Confirmation de suppression
          </AlertDialogHeader>

          <AlertDialogBody>
            Êtes-vous sûr de vouloir supprimer cet élément ?
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={onCloseAlert}>
              Annuler
            </Button>
            <Button colorScheme="red" onClick={handleDeleteConfirm} ml={3}>
              Supprimer
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
    <Footer />
    </>
  );
}

export default Home;